<template>
    <div v-if="isLoading" class="flex justify-center items-center h-screen">
      <div class="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
    </div>
    <div v-if="!isLoading" class="flex justify-center items-center">
        <div class="space-y-10 p-16 bg-white rounded-md shadow-md w-full max-w-xl">
            <h2 class="text-2xl font-bold text-indigo-800 text-center">Demo Form</h2>
            <div class="space-y-2">
                <label for="firstName" class="block text-sm font-semibold text-gray-700">First Name</label>
                <input
                type="text"
                id="firstName"
                v-model="formData.firstName"
                required
                placeholder="First Name"
                class="w-full px-1 py-2 border border-gray-300 rounded-sm shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                :class="{'border-red-600': errors.firstName}"
                />
            </div>
        
            <div class="space-y-2">
                <label for="lastName" class="block text-sm font-semibold text-gray-700">Last Name</label>
                <input
                type="text"
                id="lastName"
                v-model="formData.lastName"
                required
                placeholder="Last Name"
                class="w-full px-1 py-2 border border-gray-300 rounded-sm shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                :class="{'border-red-600': errors.lastName}"
                />
            </div>
        
            <div class="space-y-2">
                <label for="email" class="block text-sm font-semibold text-gray-700">Email</label>
                <input
                type="email"
                id="email"
                v-model="formData.email"
                required
                placeholder="Email"
                class="w-full px-1 py-2 border border-gray-300 rounded-sm shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                :class="{'border-red-600': errors.email}"
                />
            </div>
        
            <div class="flex justify-center">
                <button v-on:click="submitForm" 
                    class="w-full inline-flex justify-center py-3 border border-transparent text-sm font-semibold rounded-sm shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >Start Demo
                </button>
            </div>
        
            <div v-if="errorMessage" class="mt-4 text-center text-sm font-medium">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>
  
<script>
  import { ref } from 'vue';
  import axios from 'axios';
  import { useCommonHead } from '@/composables/useCommonHead';
  import { useRoute, useRouter } from 'vue-router';
  import { postEsignContractData } from '@/api/wordpress';  

  export default {
    name: 'DemoForm',
    props: {
        leadType: {
            type: String,
            required: true
        },
        pageTitle: {
            type: String
        },
        pageDescription: {
            type: String
        },
        currentUrl: {
            type: String
        },
    },
    setup(props) {
        const formData = ref({
            firstName: '',
            lastName: '',
            email: ''
        });

        const errors = ref({
            firstName: '',
            lastName: '',
            email: ''
        });
        
        const router = useRouter();
        const isSubmitting = ref(false);
        const errorMessage = ref('');
        const hasError = ref(false);
        const isLoading = ref(false);

        //Set up head using useCommonHead
        /*const pageTitle = 'Demo Form';
        const pageDescription = 'Fill out the demo form to get started.';
        const currentUrl = '';
        useCommonHead(pageTitle, pageDescription, currentUrl);*/

         // Set up head using useCommonHead
         useCommonHead(props.pageTitle, props.pageDescription, props.currentUrl); 

        const validateFields = (form) => {
            let isValid = true;
            errors.value = { firstName: '', lastName: '', email: '' };

            Object.keys(form).forEach(field => {
                if (!form[field]) {
                    errors.value[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required.`;
                    isValid = false;
                }
            });

            return isValid;
        };
        
        const submitForm = async () => {
            console.log('leadType:', props.leadType);
            console.log(formData.value);

            if (!validateFields(formData.value)) {
                console.log('Please fill in all fields.');
                return;
            }

            const leadDetail = {
                firstName: formData.value.firstName,
                lastName: formData.value.lastName,
                email: formData.value.email
            };
            const payload = { leadDetail }; 
            console.log(payload);

            isLoading.value = true; 
            const endpointUrl = `/lead?type=` + props.leadType;
            console.log('endpointUrl : ' + endpointUrl);
            try {
                const response = await postEsignContractData(endpointUrl, payload);
                if (response.success) {
                    console.log(response);
                    setTimeout(() => {
                        isLoading.value = false;
                    }, 2000);
                    console.log('Demo Form submitted!');
                    console.log(response.data);
                    
                    if(props.leadType == 'contract'){
                        router.push({path: '/demo/e-signature', query: {id: response.data.eSignatureWrapper.contractId}});
                    }
                    if(props.leadType == 'survey'){
                        router.push({path: '/demo/survey', query: {id: response.data.surveyWrapper.surveyId}});
                    }
                    
                }else { 
                    console.log('response.success : ' + response.success);
                }
            } catch (error) {
                isLoading.value = false;
                hasError.value = true;
                errorMessage.value = error;
                console.error('Error submitting form:');
                console.error(error);
            } 
            
        };

        return {
            formData,
            isSubmitting,
            errorMessage,
            hasError,
            submitForm,
            isLoading,
            errors
        };
    }
  }
</script>

<style scoped>

</style>